module.exports = __webpack_public_path__ + "img/hero-catch-copy.ba59723.svg";